




























import { Component, Vue } from 'vue-property-decorator';
import RandomTweetList from '@/organisms/random-tweet-list.vue';
import TweetForm from '@/organisms/tweet-form.vue';
import NotFound from '@/organisms/not-found.vue';

@Component({
  components: {
    'random-tweet-list': RandomTweetList,
    'tweet-form': TweetForm,
    'not-found': NotFound,
  },
})
export default class Home extends Vue {

  private eventPathPhrase: string | null = null;

  private created(): void {
    console.log(this.$route.query);
    this.eventPathPhrase = this.$route.query.epp as string || null;
  }

  private mounted(): void {
     if (this.possibleLoadEvent) this.setRandomTweetAreaHeight();
    // window.addEventListener('resize', this.setRandomTweetAreaHeight);
  }

  private setRandomTweetAreaHeight(): void {

    const headerElement = this.$parent.$refs.header as HTMLElement;
    const footerElement = this.$parent.$refs.footer as HTMLElement;
    const randomTweetArea = this.$refs.randomTweetArea as HTMLElement;

    const baseHeight = window.innerHeight > 500 ? window.innerHeight : 500;
    randomTweetArea.style.height = baseHeight - headerElement.clientHeight + 'px';

  }

  private get possibleLoadEvent() {
    return this.eventPathPhrase !== null;
  }

}
